import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}

export default function Aboutus({ meta, jsonLd }) {

  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="About-us">
        <section className="about2">
          <div className="bannercont">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center mt-5">
                  <h1 className="mb-2">About Millance</h1>
                  <p className="mb-3">
                    Your Trusted Partner in Trading Success
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <div className="girlimage">
                    <img
                      src={"/images/aboutus/About-Us-02.png"}
                      alt="logo"
                      className="img-fluid mt-5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="page_top_text pt-5">
          <div className="container">
            <div className="row align-item-center">
              <div className="col-lg-5">
                <div className="images">
                  <img
                    src={"/images/aboutus/about2.png"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-sm-12 m-auto">
                <div className="page_top_text_content">
                  <h2>Who We Are </h2>
                  <p>
                    Millance LTD is a globally recognized financial services
                    provider specializing in forex (FX) trading, contracts for
                    difference (CFD) trading, and multi-asset investment
                    solutions. Our platform empowers traders of all experience
                    levels with cutting-edge technology, superior market
                    conditions, and dedicated support. Committed to
                    transparency, innovation, and excellence, we help traders
                    and investors navigate global financial markets with
                    confidence and efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="regulation-content mt-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 m-auto">
                <h2 className="mb-2 text-center">Legal Documents</h2>
                <p className="text-center">Millance Ltd is proud to be regulated by the Comoros. Our license number is L15996/ML, and our company is registered under number 15996. This regulation ensures that we adhere to the highest standards of financial conduct.</p>
                <div className="license-details">
                  <h5>License Details</h5>
                  <ul className="license p-0">
                    <li>License Number:<span className="mx-2">L15996/ML</span></li>
                    <li>Company Number:<span className="mx-2">15996</span></li>
                    <li>Valid Until: :<span className="mx-2">March 13 2027</span></li>
                    <li>Government Notice:<span className="mx-2">005 OF 2005</span></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5">
                <a href={"/documents/Millance Ltd License.pdf"} target="blank">
                  <img
                    src={"/images/home/banner-regulartory.png"}
                    alt="logo"
                    className="img-fluid bannerimg1"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
        <div className="millance Values _text mt-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 m-auto ">
                <div className="millance Values _text_content ">
                  <h2>Our Mission </h2>
                  <p>
                    At Millance LTD, our mission is to create a highly
                    efficient, accessible, and rewarding trading ecosystem. We
                    provide state-of-the-art trading platforms, in-depth market
                    insights, and tailored support to help clients maximize
                    their financial potential. Our goal is to simplify trading,
                    enhance profitability, and drive long term success for our
                    partners and traders.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-5 mb-5" >
          <div className="row">
            <div className="col-lg-6">
              <img src={'/images/aboutus/ourfu.png'} alt="logo" className='Offerimg img-fluid' />
            </div>
            <div className="col-lg-6 m-auto">
              <div className="Commissions mt-3 ">
                <h2 className="me-2">What We Offer</h2>
                <div className="row">
                  <div className="col-lg-6">
                    <p>
                      <i className="altick">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                        </svg>
                      </i>
                      High CPA & IB Commissions
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <i className="altick">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                        </svg>
                      </i>
                      Multi-Asset Trading Opportunities
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <i className="altick">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                        </svg>
                      </i>
                      User-Friendly Platforms
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <i className="altick">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                        </svg>
                      </i>
                      Reliable Liquidity & Market Access
                    </p>
                  </div>
                  <div className="col-lg-6">

                    <p>
                      <i className="altick">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                        </svg>
                      </i>
                      Personalized Partner Support
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <i className="altick">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                        </svg>
                      </i>
                      Seamless Withdrawals & Payments
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row " >
            <div className="col-lg-6 m-auto">
              <div className="Commissions card mt-4 mb-4">
                <h2>Our Core Values</h2>
                <p>At Millance LTD, we are built on trust, transparency, and integrity. We uphold the highest industry standards to ensure a fair and seamless trading experience for all clients. Our trading solutions provide real market order execution, unrestricted access to price feeds and liquidity, and a commitment to operational excellence. By fostering long-term partnerships based on ethics, reliability, and continuous innovation, we are shaping the future of trading.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
